import React, { useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import LoginTypes from "../../../../enums/LoginType";

// How the admin identifies the user: a raw UserId, or a phone/email that the
// page resolves to a UserId (via the user's credits).
export const LookupMode = {
  UserId: "userId",
  Phone: "phone",
  Email: "email",
};

const MODES = [
  { value: LookupMode.UserId, label: "Kullanıcı ID", placeholder: "Örn. 6482" },
  { value: LookupMode.Phone, label: "Telefon", placeholder: "Telefon numarası" },
  { value: LookupMode.Email, label: "E-posta", placeholder: "E-posta adresi" },
];

export const lookupModeToLoginType = (mode) =>
  mode === LookupMode.Email ? LoginTypes.Email : LoginTypes.PhoneNumber;

// Presentational: owns only the input state, the page resolves the lookup.
export default function UserLookupCard({ loading, onLookup }) {
  const [mode, setMode] = useState(LookupMode.UserId);
  const [value, setValue] = useState("");

  const current = MODES.find((m) => m.value === mode);
  const trimmed = value.trim();
  const isValid =
    mode === LookupMode.UserId ? /^\d+$/.test(trimmed) && Number(trimmed) > 0 : trimmed.length > 0;

  const submit = () => {
    if (!isValid || loading) return;
    onLookup(mode, trimmed);
  };

  return (
    <div className="uc-lookup">
      <div className="uc-segmented">
        {MODES.map((m) => (
          <button
            key={m.value}
            type="button"
            className={"uc-segmented-item " + (m.value === mode ? "active" : "")}
            onClick={() => {
              setMode(m.value);
              setValue("");
            }}
          >
            {m.label}
          </button>
        ))}
      </div>

      <div className="uc-lookup-row">
        <div className="uc-input-wrapper">
          <SearchIcon className="uc-input-icon" />
          <input
            className="uc-input uc-input-with-icon"
            type="text"
            inputMode={mode === LookupMode.UserId ? "numeric" : "text"}
            placeholder={current.placeholder}
            value={value}
            onChange={(e) => setValue(e.currentTarget.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") submit();
            }}
          />
        </div>
        <button
          type="button"
          className="uc-btn uc-btn-primary"
          onClick={submit}
          disabled={!isValid || loading}
        >
          {loading ? "Aranıyor…" : "Kullanıcıyı Getir"}
        </button>
      </div>
    </div>
  );
}
